export function errorNotification(errorText) {
  this.$notification.error({
    message: errorText || 'An error occurred. Try again later'
  })
}
